export default function selections() {
  const notificationContentEl = document.querySelector(".js-notification-content");
  const hiddenInputEl = document.querySelector(".js-selection-input");
  const notificationEl = document.querySelector(".js-notification");

  const matchRows = Array.from(document.querySelectorAll(".timeline__row"));
  const cardBtns = Array.from(document.querySelectorAll(".js-card-btn"));
  const seriesBtns = Array.from(document.querySelectorAll(".js-series-btn"));
  const playoffBtn = document.querySelector(".js-playoff-btn");
  const filterBtns = Array.from(document.querySelectorAll(".js-timeline-filter"));
  const abonimentBtns = Array.from(document.querySelectorAll(".js-aboniment-btn"));

  if (
    !notificationContentEl &&
    !hiddenInputEl &&
    !matchRows.length &&
    !abonimentBtns.length &&
    !seriesBtns.length &&
    !filterBtns.length &&
    !playoffBtn
  ) {
    return;
  }

  const selectedAboniments = new Set();
  let playoffSelected = false;

  const seriesMap = new Map(); // seriesId -> matchId[]
  const matchToSeries = new Map(); // matchId -> seriesId
  const seriesElsById = new Map(); // seriesId -> Element
  const seriesOrder = [];
  let abonimentOrder = [];

  // match selection sources: matchId -> Set<reason>
  // reasons:
  // - "manual"
  // - "all"
  // - `filter:${filterName}`
  // - `series:${seriesId}`
  const matchReasons = new Map();

  const getReasonSet = (matchId) => {
    if (!matchId) return null;
    let set = matchReasons.get(matchId);
    if (!set) {
      set = new Set();
      matchReasons.set(matchId, set);
    }
    return set;
  };

  const hasMatchAnyReason = (matchId) => {
    const set = matchReasons.get(matchId);
    return Boolean(set && set.size);
  };

  const parseNumberSuffix = (id) => {
    const m = String(id || "").match(/(\d+)$/);
    return m ? Number(m[1]) : Number.POSITIVE_INFINITY;
  };

  const decl = (n, one, few, many) => {
    const abs = Math.abs(n);
    const mod100 = abs % 100;
    if (mod100 >= 11 && mod100 <= 19) return many;
    const mod10 = abs % 10;
    if (mod10 === 1) return one;
    if (mod10 >= 2 && mod10 <= 4) return few;
    return many;
  };

  const normalizeLabels = (labelsStr) =>
    String(labelsStr || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

  const getMatchId = (rowEl) => rowEl?.dataset?.matchId || null;

  const syncMatchSelectedClass = (matchId, rowEl) => {
    if (!matchId) return;
    const isSelected = hasMatchAnyReason(matchId);
    if (isSelected) rowEl?.classList?.add("selected");
    else rowEl?.classList?.remove("selected");
  };

  const addMatchReason = (matchId, rowEl, reason) => {
    if (!matchId) return;
    const set = getReasonSet(matchId);
    set?.add(reason);
    syncMatchSelectedClass(matchId, rowEl);
  };

  const removeMatchReason = (matchId, rowEl, reason) => {
    if (!matchId) return;
    const set = getReasonSet(matchId);
    set?.delete(reason);
    syncMatchSelectedClass(matchId, rowEl);
  };

  const clearMatchReasonFromAll = (reason) => {
    matchRows.forEach((rowEl) => {
      const matchId = getMatchId(rowEl);
      if (!matchId) return;
      removeMatchReason(matchId, rowEl, reason);
    });
  };

  const setPlayoffSelected = (isSelected) => {
    playoffSelected = Boolean(isSelected);
    const playoffSeriesEl = document.querySelector(".timeline__series_playoff");
    if (playoffSelected) playoffSeriesEl?.classList?.add("active");
    else playoffSeriesEl?.classList?.remove("active");
  };

  const setAbonimentSelected = (abonimentId, cardEl, isSelected) => {
    if (!abonimentId) return;
    if (isSelected) {
      selectedAboniments.add(abonimentId);
      cardEl?.classList?.add("selected");
    } else {
      selectedAboniments.delete(abonimentId);
      cardEl?.classList?.remove("selected");
    }
  };

  const isAllMatchesFilterActive = () =>
    Boolean(document.querySelector('.js-timeline-filter[data-filter="all"]')?.classList.contains("active"));

  const deactivateAllMatchesFilter = () => {
    document.querySelector('.js-timeline-filter[data-filter="all"]')?.classList.remove("active");
  };

  const clearAllMatchReasons = (matchId, rowEl) => {
    if (!matchId) return;
    matchReasons.delete(matchId);
    rowEl?.classList?.remove("selected");
  };

  const clearAllReasonsForMatches = (rows) => {
    rows.forEach((rowEl) => {
      const matchId = getMatchId(rowEl);
      if (!matchId) return;
      clearAllMatchReasons(matchId, rowEl);
    });
  };

  const getMatchesByFilter = (filter) => {
    return matchRows.filter((rowEl) => {
      const labels = normalizeLabels(rowEl.dataset.labels);
      return labels.includes(filter);
    });
  };

  const setFilterActive = (filter, isActive) => {
    document
      .querySelector(`.js-timeline-filter[data-filter="${filter}"]`)
      ?.classList.toggle("active", Boolean(isActive));
  };

  const updateFilterStates = () => {
    const labelFilters = ["top", "weekend", "allow"];
    labelFilters.forEach((filter) => {
      const rows = getMatchesByFilter(filter);
      if (!rows.length) {
        setFilterActive(filter, false);
        return;
      }
      const allSelected = rows.every((rowEl) => {
        const mid = getMatchId(rowEl);
        return mid ? hasMatchAnyReason(mid) : false;
      });
      setFilterActive(filter, allSelected);
    });

    // "all" активен, только если выбраны вообще все матчи + плей-офф
    const allMatchesSelected =
      matchRows.length > 0 &&
      matchRows.every((rowEl) => {
        const mid = getMatchId(rowEl);
        return mid ? hasMatchAnyReason(mid) : false;
      });
    setFilterActive("all", Boolean(allMatchesSelected && playoffSelected));
  };

  const render = () => {
    // series collapse: если в серии выбраны все матчи => учитываем серией, иначе матчами
    const seriesSelectedIds = [];
    const matchSelectedIds = [];

    seriesOrder.forEach((seriesId) => {
      const matchIds = seriesMap.get(seriesId) || [];
      if (!matchIds.length) return;

      const allSelected = matchIds.every((mid) => hasMatchAnyReason(mid));
      const seriesEl = seriesElsById.get(seriesId);
      if (seriesEl) seriesEl.classList.toggle("active", allSelected);
      if (allSelected) {
        seriesSelectedIds.push(seriesId);
      } else {
        matchIds.forEach((mid) => {
          if (hasMatchAnyReason(mid)) matchSelectedIds.push(mid);
        });
      }
    });

    // если вдруг появятся матчи без серии — добавим их тоже
    matchRows.forEach((rowEl) => {
      const mid = getMatchId(rowEl);
      if (!mid) return;
      if (!hasMatchAnyReason(mid)) return;
      if (!matchToSeries.has(mid)) matchSelectedIds.push(mid);
    });

    matchSelectedIds.sort((a, b) => parseNumberSuffix(a) - parseNumberSuffix(b));

    const abonimentIds = abonimentOrder.filter((id) => selectedAboniments.has(id));

    const parts = [];
    if (seriesSelectedIds.length) {
      parts.push(`${seriesSelectedIds.length} ${decl(seriesSelectedIds.length, "серия", "серии", "серий")}`);
    }
    if (matchSelectedIds.length) {
      parts.push(`${matchSelectedIds.length} ${decl(matchSelectedIds.length, "матч", "матча", "матчей")}`);
    }
    if (abonimentIds.length) {
      parts.push(
        `${abonimentIds.length} ${decl(abonimentIds.length, "абонемент", "абонемента", "абонементов")}`
      );
    }
    if (playoffSelected) parts.push("плей-офф");

    const text = parts.join(", ");

    if (notificationContentEl) notificationContentEl.textContent = text;
    if (hiddenInputEl) hiddenInputEl.value = [
      ...seriesSelectedIds,
      ...matchSelectedIds,
      ...abonimentIds,
      ...(playoffSelected ? ["playoff"] : [])
    ].join(",");

    const hasAnySelection =
      Boolean(seriesSelectedIds.length || matchSelectedIds.length || abonimentIds.length || playoffSelected);

    if (notificationEl) {
      if (hasAnySelection) notificationEl.classList.add("open");
      else notificationEl.classList.remove("open");
    }

    updateFilterStates();
  };

  // init series ids + map matches -> series
  const sections = Array.from(document.querySelectorAll(".timeline__section"));
  let seriesCounter = 0;
  sections.forEach((sectionEl) => {
    const seriesBtnEl = sectionEl.querySelector(".js-series-btn");
    if (!seriesBtnEl) return;

    const seriesEl = sectionEl.querySelector(".timeline__series");
    let seriesId = seriesEl?.dataset?.seriesId;

    if (!seriesId) {
      seriesCounter += 1;
      seriesId = `series${seriesCounter}`;
      if (seriesEl) seriesEl.dataset.seriesId = seriesId;
    }

    const matchIds = Array.from(sectionEl.querySelectorAll(".timeline__row"))
      .map((rowEl) => getMatchId(rowEl))
      .filter(Boolean);

    seriesMap.set(seriesId, matchIds);
    seriesOrder.push(seriesId);
    matchIds.forEach((mid) => matchToSeries.set(mid, seriesId));

    if (seriesEl) {
      seriesElsById.set(seriesId, seriesEl);
    }
  });

  // init aboniments from data-aboniment-id
  const abonimentCards = Array.from(document.querySelectorAll(".aboniments__card"));
  abonimentOrder = abonimentCards
    .map((cardEl) => cardEl.dataset.abonimentId)
    .filter(Boolean);

  abonimentCards.forEach((cardEl, idx) => {
    if (!cardEl.dataset.abonimentId) {
      cardEl.dataset.abonimentId = `aboniment${idx + 1}`;
      abonimentOrder.push(cardEl.dataset.abonimentId);
    }
    if (cardEl.classList.contains("selected")) {
      selectedAboniments.add(cardEl.dataset.abonimentId);
    }
  });

  // init selected matches from DOM
  matchRows.forEach((rowEl) => {
    const matchId = getMatchId(rowEl);
    if (!matchId) return;
    if (rowEl.classList.contains("selected")) {
      addMatchReason(matchId, rowEl, "manual");
    }
  });

  // aboniments click
  abonimentBtns.forEach((btnEl) => {
    btnEl.addEventListener("click", () => {
      const cardEl = btnEl.closest(".aboniments__card");
      if (!cardEl) return;
      const abonimentId = cardEl.dataset.abonimentId;
      const next = !cardEl.classList.contains("selected");
      setAbonimentSelected(abonimentId, cardEl, next);
      window.showNotif?.();
      render();
    });
  });

  // match click (manual)
  cardBtns.forEach((btnEl) => {
    btnEl.addEventListener("click", () => {
      const rowEl = btnEl.closest(".timeline__row");
      const matchId = getMatchId(rowEl);
      if (!rowEl || !matchId) return;

      const isSelected = hasMatchAnyReason(matchId);
      if (isSelected) {
        // снимаем матч целиком (неважно, выбран он фильтрами/серией/всеми матчами)
        clearAllMatchReasons(matchId, rowEl);
      } else {
        // включаем матч вручную
        addMatchReason(matchId, rowEl, "manual");
      }

      // если "все матчи" было активно и мы убрали хотя бы один матч — выключаем фильтр
      if (isAllMatchesFilterActive() && isSelected) {
        deactivateAllMatchesFilter();
      }

      window.showNotif?.();
      render();
    });
  });

  // series click: toggle all matches in section
  seriesBtns.forEach((btnEl) => {
    btnEl.addEventListener("click", () => {
      const sectionEl = btnEl.closest(".timeline__section");
      if (!sectionEl) return;

      const rows = Array.from(sectionEl.querySelectorAll(".timeline__row"));
      const matchIds = rows.map((r) => getMatchId(r)).filter(Boolean);
      if (!matchIds.length) return;

      const seriesId = sectionEl.querySelector(".timeline__series")?.dataset?.seriesId;
      if (!seriesId) return;
      const reason = `series:${seriesId}`;

      const allSelected = matchIds.every((mid) => (mid ? hasMatchAnyReason(mid) : false));
      rows.forEach((rowEl) => {
        const mid = getMatchId(rowEl);
        if (!mid) return;
        if (!allSelected) addMatchReason(mid, rowEl, reason);
        else clearAllMatchReasons(mid, rowEl);
      });

      if (isAllMatchesFilterActive() && allSelected) {
        // если снимали серию при включённом "все матчи"
        deactivateAllMatchesFilter();
      }

      window.showNotif?.();
      render();
    });
  });

  // playoff click
  playoffBtn?.addEventListener("click", () => {
    const next = !playoffSelected;
    setPlayoffSelected(next);
    if (isAllMatchesFilterActive() && !next) deactivateAllMatchesFilter();
    window.showNotif?.();
    render();
  });

  // filters
  filterBtns.forEach((btnEl) => {
    btnEl.addEventListener("click", () => {
      const filter = btnEl.dataset.filter;
      if (!filter) return;

      if (filter === "all") {
        // exclusive
        setFilterActive("top", false);
        setFilterActive("weekend", false);
        setFilterActive("allow", false);

        const next = !btnEl.classList.contains("active");
        btnEl.classList.toggle("active", next);

        if (next) {
          // выбрать все матчи (через reason all) и плей-офф
          matchRows.forEach((rowEl) => {
            const matchId = getMatchId(rowEl);
            addMatchReason(matchId, rowEl, "all");
          });
          setPlayoffSelected(true);
        } else {
          // снять все матчи полностью + плей-офф
          clearAllReasonsForMatches(matchRows);
          setPlayoffSelected(false);
        }

        window.showNotif?.();
        render();
        return;
      }

      // non-all filter: disables "all"
      deactivateAllMatchesFilter();
      const next = !btnEl.classList.contains("active");
      btnEl.classList.toggle("active", next);

      const reason = `filter:${filter}`;
      const rows = getMatchesByFilter(filter);
      rows.forEach((rowEl) => {
        const matchId = getMatchId(rowEl);
        if (!matchId) return;
        if (next) addMatchReason(matchId, rowEl, reason);
        else removeMatchReason(matchId, rowEl, reason);
      });

      window.showNotif?.();
      render();
    });
  });

  render();
}